__turbopack_context__.v({
  "chevron": "styles-module-scss-module__XgVXdG__chevron",
  "container": "styles-module-scss-module__XgVXdG__container",
  "controls": "styles-module-scss-module__XgVXdG__controls",
  "icon": "styles-module-scss-module__XgVXdG__icon",
  "navBtn": "styles-module-scss-module__XgVXdG__navBtn",
  "prev": "styles-module-scss-module__XgVXdG__prev",
  "root": "styles-module-scss-module__XgVXdG__root",
  "slide": "styles-module-scss-module__XgVXdG__slide",
  "title": "styles-module-scss-module__XgVXdG__title",
  "viewport": "styles-module-scss-module__XgVXdG__viewport",
});
